
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import { AlertTitleTh, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { BtnAdd, BtnEditOnTable, BtnIconSearch, BtnSearch } from 'components/Common/Button';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import {
    DataGridMui as Table,
    initRows,
    PaginationInterface,
} from "components/Common/Table/DataGridMui";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import ContentWrapper from 'components/Common/style/ContentWrapper';
import { useNavigate } from 'react-router-dom';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import moment from 'moment';
import { SwAlert } from 'components/Common/Alert/AlertForm';

const UserPermissionList = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const navigate = useNavigate();

    const [loadingTable, setLoadingTable] = useState(true);
    const [arrData, setArrData] = useState([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc"
    });

    const [Option, setOption] = useState({
        lstRole: [],
        lstBA: []
    })

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    //#region  Form
    let objSchema = {
        sSearch: yupFormSchemas.string("รหัสพนักงาน, ชื่อ, สกุล, อีเมล", { required: false }),
        arrCompany: yupFormSchemas.stringArray("บริษัท", { required: false }),
        arrBA: yupFormSchemas.stringArray("กลุ่มตลาด", { required: false }),
        oStatus: yupFormSchemas.object("สถานะ", { required: false }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    const OptionStatus = [
        { value: "1", label: "ใช้งาน" },
        { value: "0", label: "ไม่ใช้งาน" },
    ]

    useEffect(() => {
        GetInit()
        loadData(dataRow);
    }, [])

    const GetInit = () => {
        AxiosGet("UserPermission/GetInitPrs", {}, (res) => {

            var result = {
                lstRole: res.optionRole,
                lstBA: res.optionBA
            }

            setOption(result)
        })
    }

    const loadData = (p: PaginationInterface = dataRow) => {
        // BlockUI();
        setLoadingTable(true)
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        let obj = {
            ...p,
            sSearch: form.getValues("sSearch"),
            arrRole: form.getValues("arrRole") || [],
            arrBA: form.getValues("arrBA") || [],
            sStatusID: form.getValues("oStatus") != null ? form.getValues("oStatus").value : null

        }
        AxiosPost(`UserPermission/onSearchUserPermission`, obj, (res) => {
            // UnBlockUI();
            ResultAPI(res, null, () => {
                setLoadingTable(false)
                setArrData(res.result.lstData || [])
                setDataRow({
                    ...p,
                    arrRows: res.result.lstData || [],
                    nDataLength: res.result.nDataLength,
                    nPageIndex: res.result.nPageIndex,
                });
            })
        })
    };

    const onDelete = (nRow) => {
        let sMessage = "คุณต้องการที่จะลบข้อมูลใช่หรือไม่ ?"
        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();
    
            let data = nRow.map((item) => arrData.findIndex(f => f.nRow === item))
            let result = data.map((item) => arrData[item].sUserID)
    
            AxiosPost(`UserPermission/DeleteUser`, { sUserID: result });
    
            setTimeout(() => {
                setIsOpenSnackbar(true);
                setsMessageSnackbar("ลบข้อมูลสำเร็จ")
                setsSeveritySnackbar("success")
                UnBlockUI();
                loadData()
            }, 3000);
        })       

    }

    const onEdit = (id) => {
        let sUrl_state = "/Backend/Admin/UserPermissionForm";
        navigate(sUrl_state, { state: { sID: id } });
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 50,
            editable: false,
            // resizable: false,
            // disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sEmpCode",
            headerName: "รหัสพนักงาน",
            headerAlign: "center",
            flex: 2,
            align: "center",
            // resizable: false,
            // disableReorder: true,
            minWidth: 100,
            sortable: true,
        },
        {
            field: "sFullname",
            headerName: "ชื่อ-สกุล",
            headerAlign: "center",
            flex: 3,
            align: "left",
            // resizable: false,
            // disableReorder: true,
            minWidth: 200,
            sortable: true,
        },
        {
            field: "sRole",
            headerName: "Role",
            headerAlign: "center",
            flex: 4,
            align: "left",
            // resizable: false,
            // disableReorder: true,
            minWidth: 100,
            sortable: true,
        },
        {
            field: "sBA",
            headerName: "กลุ่มตลาด",
            headerAlign: "center",
            flex: 3,
            align: "center",
            // resizable: false,
            // disableReorder: true,
            minWidth: 100,
            sortable: true,
        },
        {
            field: "sBSARefUnitCode",
            headerName: "หน่วยงาน ปตท. (ฝ่าย)",
            headerAlign: "center",
            flex: 2,
            align: "center",
            // resizable: false,
            // disableReorder: true,
            minWidth: 100,
            sortable: true,
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            resizable: false,
            disableReorder: true,
            flex: 2,
            sortable: true,
        },
        {
            field: "sUpdate",
            headerName: "แก้ไขโดย",
            headerAlign: "center",
            flex: 2,
            align: "left",
            // resizable: false,
            // disableReorder: true,
            minWidth: 100,
            sortable: true,
        },
        {
            field: "dUpdate",
            headerName: "วันที่แก้ไขล่าสุด",
            headerAlign: "center",
            flex: 3,
            align: "center",
            minWidth: 150,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            headerName: "",
            field: "",
            type: "actions",
            flex: 1,
            minWidth: 50,
            resizable: false,
            sortable: false,
            getActions: (item) => {
                return [
                    (
                        <BtnEditOnTable onClick={() => onEdit(item.row.sUserID)} />
                    )
                ];
            },
        },
    ];

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<ManageAccountsIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="ผู้ดูแลระบบ"
                label_nameRoute="จัดการข้อมูลผู้ใช้งาน"
            />
            <FormProvider {...form}>
                <ContentWrapper>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                        <Grid item xs={12}>
                            <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center" >
                                <Grid item xs={12} sm={"auto"}>
                                    <BtnAdd txt={"สร้างรายการ"} onClick={() => { navigate("/Backend/Admin/UserPermissionForm") }} />
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <Grid container spacing={1} direction="row" justifyContent="end" alignItems="center" >
                                        <Grid item xs={12} sm={4}>
                                            <InputFormItem
                                                id="sSearch"
                                                name="sSearch"
                                                label="รหัสพนักงาน, ชื่อ, สกุล, อีเมล"
                                                required={false}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2.5}>
                                            <MultiSelectForm
                                                name="arrRole"
                                                options={Option.lstRole || []}
                                                label={"Role"}
                                                required={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2.5}>
                                            <MultiSelectForm
                                                name="arrBA"
                                                options={Option.lstBA || []}
                                                label={"กลุ่มตลาด"}
                                                required={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <AutoCompleteSelect
                                                name="oStatus"
                                                options={OptionStatus || []}
                                                label={"สถานะ"}
                                                required={false}
                                            />
                                        </Grid>
                                        <Grid item xs={"auto"}>
                                            <BtnIconSearch onClick={() => { loadData() }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Table
                                isLoading={loadingTable}
                                OnLoadData={(p) => loadData(p)}
                                Rows={dataRow}
                                HiddenToolHead={true}
                                Columns={dataColumn}
                                backgroundHeaderCustom={"#004290"}
                                sxCustomHeader={{ color: '#ffffff' }}
                                onDelete={(d) => onDelete(d)}
                                isShowCheckBox={true}
                            />
                        </Grid>
                    </Grid>
                </ContentWrapper>

            </FormProvider>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default UserPermissionList